import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return Localization.get('badoo_safety_center@navigation.tools.title');
    },

    lxBlockText() {
        return Localization.get('badoo_safety_center@tools.text');
    },

    lxBlockCta() {
        return Localization.get('badoo_safety_center@tools.cta');
    },

    lxBlockMobileCloseCta() {
        return (
            Localization.get('badoo_safety_center@tools.closeCta')
                // @TODO - remove this fix after lexemes will be fixed here
                // https://jira.badoojira.com/browse/LOC-6177
                ?.toLowerCase()
        );
    },

    lxCloseSectionA11yLabel() {
        return Localization.get('badoo_safety_center@tools.close.a11y.label');
    },
};
